import { DeepPartialWithNull } from "shared/types/DeepPartial"
import {
  ProjectPhaseTypename,
  ProjectTypename,
  ProjectUITypename
} from "shared/types/Project"

import { ClarificationRequestSchema } from "entities/clarification-requests/types/ClarificationRequest"
import { z } from "zod"

export const ProjectFormDataSchema = z.object({
  project: z.object({
    title: z.string().min(2),
    description: z.string().nullable().optional(),
    inflationSurcharge: z.number().nullable().optional(),
    priceList: z.string().nullable().optional(),
    phase: z.object({
      id: z.string(),
      label: z.string(),
      value: z.string(),
      __typename: z
        .literal(ProjectPhaseTypename)
        .optional()
        .transform(() => ProjectPhaseTypename)
    }),
    ui: z
      .object({
        color: z.string().nullable().optional(),
        __typename: z
          .literal(ProjectUITypename)
          .optional()
          .transform(() => ProjectUITypename)
      })
      .nullish(),
    __typename: z
      .literal(ProjectTypename)
      .optional()
      .transform(() => ProjectTypename)
  }),
  clarificationRequest: ClarificationRequestSchema.nullish()
})

export type ProjectFormData = z.infer<typeof ProjectFormDataSchema>
export type ProjectFormState = DeepPartialWithNull<ProjectFormData>
